<template>
  <div :class="{ scrollOn: !starOn }" class="presskit" :key="rerender">
    <section :class="{ starWars: starOn }">
      <div :class="{ crawl: starOn, mobileCrawl: !starOn }" id="content">
        <div class="title">
          <p>Kizi 404</p>
          <h1>A New Hope</h1>
        </div>
        <p>
          Jaded by a world in which receiving a notification justifies
          interrupting any conversation, 4 compadres in search of meaning find
          themselves in the depths of the Canadian forest to embark on the
          longest jam session of all time.
        </p>
        <p>
          Months of improvisation and messing around have already passed when an
          elusive radio signal infiltrates their circuitry, giving them hope of
          a Somewhere or Someone else.
        </p>
        <p>
          Combining their sets of skills, the newly formed crew assembles a DIY
          spaceship jam-packed with classic cuts, synths and samples. On
          takeoff, strapped and ready for hyperjump, the squad drops their first
          musical care package for the people of Earth and elsewhere. Many more
          of these beauties will come.
        </p>
        <p>
          To learn more about Kizi404's odyssey, wander inside the ship, explore
          our Galactic library or access the Maproom.
        </p>
        <p>
          <span>Release info</span>
        

        <ul class="release-info">
          <li>
            Each release contains a password allowing you to access different
            parts of our spaceship. Once aboard, you will enter our universe and
            find out more about our story, our crew members, tracks, etc...
            <br />
          </li>
          <li>
            4 tracks, various artists
          </li>
          <li>
            500 vinyl copies
          </li>
          <li>
            No digital copies
          </li>
        </ul>
        </p>

        <p class="links">
          <span>Useful links: </span>
        

        <ul>
          <li>
            =>
            <a
              href="https://soundcloud.com/kizigarden/sets/kizi-404-enter-the-passworld-404-aaa/s-fJWk6GBTlw0"
              target="_blank"
              >Release snippets</a
            >
          </li>
          <li>=> <a href="/spaceship" target="_blank">Ship</a></li>

          <li>
            =>
            <a
              href="https://kizi404.bandcamp.com/album/enter-the-passworld"
              target="_blank"
              >Bandcamp</a
            >
          </li>

          <li>
            => <a href="https://discord.gg/vWg4vmg" target="_blank"> Discord</a>
          </li>
          <a href="mailto:kizi404@protonmail.com">
            <li>
              Mail: kizi404@protonmail.com
            </li>
          </a>
        </ul>
        </p>
      </div>
    </section>
    <div class="shutup">
      <a @click="switchStar" href="#" v-html="message"></a>
      <transition name="fade">
        <div v-show="scrollVisible">
          <p @click="rerender++">(show it again)</p>
          <p><a href="/" target="_blank">To the ship !</a></p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "PresskitOne",
  data() {
    return {
      starOn: true,
      message: "Shut the f*** up <br/> star wars <br/> (if it bugs, #sorryDIY)",
      scrollVisible: false,
      rerender: 0,
    };
  },
  methods: {
    switchStar() {
      this.starOn = !this.starOn;
      const content = document.getElementById("content");
      if (!this.starOn) {
        this.message = "Pls come back star wars";
        content.classList.add("test");
        console.log(content);
      } else
        this.message =
          "Shut the f*** up <br/> star wars <br/> (if it bugs, #sorryDIY)";
    },
  },
  mounted() {
    setTimeout(() => (this.scrollVisible = true), 15000);
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
$ratio: 40rem;
$letter: $ratio/10;

.presskit {
  background-image: url("../../assets/medias/images/spacebg.png");
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
  max-height: 100vh;
  top: 0;
  color: #feda4a;
  overflow: hidden;
  z-index: 1;
}

.scrollOn {
  overflow-y: scroll;
  max-width: 100vw;
}
ul {
  list-style: none;
}

li {
  margin-bottom: 40px;
}

.shutup {
  position: absolute;
  top: 5vh;
  left: 2vw;
  z-index: 4;
  text-align: center;
}

.starWars {
  display: flex;
  justify-content: center;
  position: relative;
  height: $ratio;
  min-width: 200vw;
  left: -50vw;
  perspective: $ratio/2;
  letter-spacing: 6px;
  text-align: justify;
}

.starWars p {
  font-size: 2 * $letter;
}
.starWars h1 {
  font-size: 3 * $letter;
}

.title {
  //font-size: 4 * $letter;
  text-align: center;
}

.links {
  text-align: initial;
}

.release-info {
  color: white;
}

.crawl {
  position: relative;
  z-index: 3;
  top: 0;
  overflow-y: visible;
  min-height: 300vh;
  transform-origin: 50% 100%;
  animation: crawl 65s forwards ease-out;
  padding-bottom: 50vh;
}

@keyframes crawl {
  0% {
    top: 2 * $ratio;
    transform: rotateX(20deg) translateZ(40vh);
  }
  100% {
    top: -10 * $ratio;
    transform: rotateX(20deg) translateZ(-4 * $ratio);
  }
}

@media only screen and (min-width: 1001px) and (max-width: 1150px) {
  @keyframes crawl {
    0% {
      top: 2 * $ratio;
      transform: rotateX(20deg) translateZ(40vh);
    }
    100% {
      top: -11 * $ratio;
      transform: rotateX(20deg) translateZ(-4 * $ratio);
    }
  }
}

@media only screen and (min-width: 701px) and (max-width: 1000px) {
  $ratio: 60rem;
  @keyframes crawl {
    0% {
      top: 2 * $ratio;
      transform: rotateX(20deg) translateZ(40vh);
    }
    100% {
      top: -10 * $ratio;
      transform: rotateX(20deg) translateZ(-4 * $ratio);
    }
  }
}

@media only screen and (max-width: 700px) {
  $ratio: 45rem;
  .starWars p {
    font-size: 1.5 * $letter;
  }
  .starWars h1 {
    font-size: 2 * $letter;
  }

  .crawl {
    animation: crawl 75s forwards ease-out;
    min-width: 250vw;
  }

  @keyframes crawl {
    0% {
      top: 2 * $ratio;
      transform: rotateX(20deg) translateZ(40vh);
    }
    100% {
      top: -10 * $ratio;
      transform: rotateX(20deg) translateZ(-5 * $ratio);
    }
  }

  .starWars {
    font-size: 2rem;
  }

  .shutup,
  .shutup p {
    font-size: 0.8rem;
  }

  .mobileCrawl {
    max-width: 100vw;
    white-space: wrap;
  }
  .mobileCrawl p {
    font-size: 2rem !important;
  }
}

.mobileCrawl {
  max-width: 85vw;
  margin: auto;
}
</style>
